import { createSelector } from 'reselect';
import BigNumber from 'bignumber.js';
import { currency } from '../../helpers/numberFormatter';
import { mergeOpenOrders } from '../../helpers/orderHelper';
import { buyOpenOrdersSelector, sellOpenOrdersSelector } from './orderHistorySelectors';
import { selectedInstrumentSelector } from './instrumentPositionSelectors';
export var convertLevel2SideDataToCurrency = function convertLevel2SideDataToCurrency() {
  return function (data, instrument, orders) {
    if (!instrument) {
      return data;
    }
    var Product1Symbol = instrument.Product1Symbol,
      Product2Symbol = instrument.Product2Symbol;
    var uniqOrders = mergeOpenOrders(orders);
    var userOrders = uniqOrders.map(function (order) {
      var quantity = currency(order.DisplayQuantity, Product1Symbol);
      return Object.assign({}, order, {
        Quantity: quantity,
        MySize: order.Quantity
      });
    });
    var level2Orders = data.map(function (order) {
      var price = currency(order.Price, Product2Symbol);
      var quantity = currency(order.Quantity, Product1Symbol);
      var userOrderIndex = userOrders.findIndex(function (item) {
        return item.Price.isEqualTo(price);
      });
      if (userOrderIndex !== -1) {
        var result = Object.assign({}, userOrders[userOrderIndex], {
          Quantity: quantity,
          MySize: userOrders[userOrderIndex].Quantity
        });
        userOrders.splice(userOrderIndex, 1);
        return result;
      }
      return Object.assign({}, order, {
        Price: price,
        Quantity: quantity
      });
    });
    return level2Orders.sort(function (a, b) {
      return b.Price.minus(a.Price);
    });
  };
};
export var level2BuySelector = createSelector([function (state) {
  return state.apexCore.level2.buy;
}, selectedInstrumentSelector, buyOpenOrdersSelector], convertLevel2SideDataToCurrency());
export var level2SellSelector = createSelector([function (state) {
  return state.apexCore.level2.sell;
}, selectedInstrumentSelector, sellOpenOrdersSelector], convertLevel2SideDataToCurrency());
export var level2Selector = createSelector([level2BuySelector, level2SellSelector], function (buy, sell) {
  return {
    buy: buy,
    sell: sell
  };
});
export var spreadSelector = createSelector([level2BuySelector, level2SellSelector], function (buy, sell) {
  var bestBuy = buy.reduce(function (acc, i) {
    if (i.Price.gt(acc)) return i.Price;
    return acc;
  }, 0);
  var bestSell = sell.reduce(function (acc, i) {
    if (i.Price.lt(acc)) return i.Price;
    return acc;
  }, Infinity);
  if (bestSell !== Infinity) {
    return bestSell.minus(bestBuy);
  }
  if (bestBuy !== 0) {
    return bestBuy.times(-1);
  }
  return new BigNumber(0);
});